<template>
  <div class="container_self">
    <el-row class="table_parent">
      <h3>小说列表</h3>
      <el-row class="add_btn"><el-button type="success" icon="el-icon-plus" size="mini" @click="addVideo">添加小说</el-button></el-row>
      <el-row style="margin:15px 0;font-size:14px">
        <span class="label">域名</span>
        <el-select v-model="domain" placeholder="请选择域名" size="mini" clearable @change="domainChange">
          <el-option v-for="(item,index) in domainList" :key="index" :label="item.dm" :value="item.dm"></el-option>
        </el-select>

        <el-button type="danger" size="mini" style="margin:0 5px 0 25px" @click="addMovieToDm">批量加入域名</el-button>
        <!-- <el-button type="warning" size="mini" @click="removeMovieToDm">从域名批量删除</el-button> -->
      </el-row>
      <el-table :data="videoList" v-loading="loading" ref="multipleTable"
          @selection-change="handleSelectionChange">
        <el-table-column
          type="selection"
          width="55" align="center"></el-table-column>
        <el-table-column
          label="小说名称"
          prop="movieName"
          align="center"
          width="200"
        ></el-table-column>
        <!-- -->
        <el-table-column
          label="排序"
          prop="sortNumber"
          align="center"
          width="50"
        ></el-table-column>
        <el-table-column
          label="语言"
          prop="lang"
          align="center"
          width="80"
        ></el-table-column>
        <el-table-column
          label="总集数"
          prop="totalEpisode"
          align="center"
        ></el-table-column>
        <el-table-column
          label="免费集数"
          prop="freeEpisode"
          align="center"
        ></el-table-column>
        <el-table-column
          label="解锁金币"
          prop="coinPrice"
          align="center"
        ></el-table-column>
        <el-table-column
          label="递增金币"
          prop="coinRate"
          align="center"
        ></el-table-column>
        <el-table-column label="播放量" prop="playCount" align="center"></el-table-column>
        <el-table-column
          label="小说分类"
          prop="categoryNameList"
          align="center"
        ></el-table-column>
        <el-table-column label="小说封面" width="300" align="center">
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              effect="dark"
              :content="scope.row.cover"
              placement="top"
            >
              <span class="table_span">{{ scope.row.cover }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="是否启用" align="center" width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.enabled ? "是" : "否" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="是否热播" align="center" width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.hot ? "是" : "否" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="是否推荐" align="center" width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.recommend ? "是" : "否" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="标签列表"
          prop="tagNameList"
          align="center"
        ></el-table-column>
        <el-table-column label="小说概要" align="center">
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              effect="dark"
              :content="scope.row.summary"
              placement="top"
            >
              <span class="table_span">{{ scope.row.summary }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column
          label="作者"
          prop="author"
          align="center"
          width="120"
        ></el-table-column>
        <!-- <el-table-column label="创建时间" prop="createTime" align="center"></el-table-column> -->
        <el-table-column label="操作" align="center" fixed="right" width="420">
          <template slot-scope="scope">
            <el-button type="danger" size="mini" @click="shareHtml(scope.row)"
              >分享</el-button
            >
            <el-button type="primary" size="mini" @click="updateVideo(scope.row)"
              >更新</el-button
            >
            <el-button type="warning" size="mini" @click="checkEpisodeForThis(scope.row)"
              >查看章节</el-button
            >
            <el-button type="success" size="mini" @click="addEpisodeForThis(scope.row)"
              >添加章节</el-button
            >
            <el-button type="danger" size="mini" @click="deleteVideo(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="videoSearch.currentPage"
        :page-sizes="[50, 100, 200]"
        :page-size="videoSearch.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
      <el-dialog
        :title="string + '小说'"
        :visible.sync="dialogFormVisible"
        :close-on-click-modal="false"
        top="0"
      >
        <el-form
          :model="addVideoForm"
          class="search_parent"
          size="mini"
          :rules="rules"
          label-width="120px"
          ref="ruleForm"
        >
          <el-form-item label="作者" prop="author">
            <el-input
              v-model="addVideoForm.author"
              placeholder="请输入作者名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="小说名称" prop="movieName">
            <el-input
              v-model="addVideoForm.movieName"
              placeholder="请输入小说名称"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="语言" prop="movieName">
            <el-input
              v-model="addVideoForm.lang"
              placeholder="请输入语言(如:zh,en,ru等)"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="免费集数" prop="freeEpisode">
            <el-input
              v-model="addVideoForm.freeEpisode"
              placeholder="请输入免费集数"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="需要金币数" prop="coinPrice">
            <el-input
              v-model="addVideoForm.coinPrice"
              placeholder="请输入需要金币数"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="金币递增数" prop="coinRate">
            <el-input
              v-model="addVideoForm.coinRate"
              placeholder="请输入需要金币数"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="上传封面">
            <el-upload
              drag
              action="https://adminapi.ci-ads.com/api/movie/upload/file"
              style="display: inline-block; margin-left: 15px"
              class="upload-demo"
              :with-credentials="true"
              multiple
              :limit="1"
              ref="uploadCover"
              accept=".jpg,.png,.webp"
              :auto-upload="true"
              :headers="{ Authorization: token }"
              :show-file-list="true"
              :on-success="handleAvatarSuccessImg"
              :file-list="fileList1"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            </el-upload>
          </el-form-item>
          <el-form-item label="封面" prop="cover">
            <el-input
              disabled
              v-model="addVideoForm.cover"
              clearable
              placeholder="请输入小说封面链接"
            ></el-input>
          </el-form-item>

          <el-form-item label="上传封面大图">
            <el-upload
              drag
              action="https://adminapi.ci-ads.com/api/movie/upload/file"
              style="display: inline-block; margin-left: 15px"
              class="upload-demo"
              :with-credentials="true"
              multiple
              :limit="1"
              ref="uploadLargeCover"
              accept=".jpg,.png,.webp"
              :auto-upload="true"
              :headers="{ Authorization: token }"
              :show-file-list="true"
              :on-success="handleAvatarSuccessImgLarge"
              :file-list="fileList2"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            </el-upload>
          </el-form-item>
          <el-form-item label="封面大图">
            <el-input
              disabled
              v-model="addVideoForm.largeCover"
              clearable
              placeholder="请输入小说封面链接"
            ></el-input>
          </el-form-item>
          <el-form-item label="VAST链接">
            <el-input
              v-model="addVideoForm.vastLink"
              clearable
              placeholder="请输入小说对应的VAST链接"
            ></el-input>
          </el-form-item>
          <el-form-item label="小说集数" prop="totalEpisode">
            <el-input
              v-model="addVideoForm.totalEpisode"
              autocomplete="off"
              clearable
              placeholder="请输入小说总集数"
            ></el-input>
          </el-form-item>
          <el-form-item label="小说分类" prop="categoryIdList">
            <el-select
              v-model="addVideoForm.categoryIdList"
              multiple
              placeholder="请选择小说分类"
              clearable
              style="width: 60%"
            >
              <el-option
                v-for="(item, index) in categoryList"
                :key="'key_' + index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="排序">
            <el-input
              v-model="addVideoForm.sortNumber"
              autocomplete="off"
              clearable
              placeholder="请输入小说总集数"
            ></el-input>
          </el-form-item>
          <el-form-item label="是否启用">
            <el-select
              v-model="addVideoForm.enabled"
              placeholder="请选择是否启用"
              clearable
              style="width: 60%"
            >
              <el-option :value="1" label="启用"></el-option>
              <el-option :value="0" label="不启用"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否热播">
            <el-select
              v-model="addVideoForm.hot"
              placeholder="请选择是否热播"
              clearable
              style="width: 60%"
            >
              <el-option :value="1" label="是"></el-option>
              <el-option :value="0" label="否"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否推荐">
            <el-select
              v-model="addVideoForm.recommend"
              placeholder="请选择是否推荐"
              clearable
              style="width: 60%"
            >
              <el-option :value="1" label="是"></el-option>
              <el-option :value="0" label="否"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="小说标签">
            <el-select
              v-model="addVideoForm.tagNameList"
              placeholder="请选择标签"
              multiple
              clearable
              style="width: 60%"
            >
              <el-option
                v-for="(item, index) in tagNameListPage"
                :key="index"
                :value="item"
                :label="item"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="小说概要">
            <el-input
              v-model="addVideoForm.summary"
              autocomplete="off"
              type="textarea"
              :rows="5"
              placeholder="请输入小说概要"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitVideoForm('ruleForm')">确 定</el-button>
        </div>
      </el-dialog>

      <el-dialog
        title=""
        :visible.sync="dialogFormVisible1"
        width="85%"
        top="3vh"
        :close-on-click-modal="false"
        :destroy-on-close="true"
      >
        <episodeManager :id="videoId" :movieName="movieName"></episodeManager>
      </el-dialog>

      <el-dialog
        :title="string + '章节'"
        :visible.sync="dialogFormVisible2"
        :close-on-click-modal="false"
        label-width="120px"
      >
        <el-form
          :model="addEpisodeForm"
          class="search_parent"
          size="mini"
          top="0"
          label-width="120px"
        >
          <el-form-item label="集数">
            <el-input
              v-model="addEpisodeForm.episode"
              placeholder="请输入当前小说在小说中的集数"
            ></el-input>
          </el-form-item>
          <el-form-item label="分集名称">
            <el-input
              v-model="addEpisodeForm.episodeName"
              autocomplete="off"
              placeholder="请输入当前小说名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="上传小说">
            <el-upload
              drag
              action="https://adminapi.ci-ads.com/api/movie/upload/file"
              style="display: inline-block; margin-left: 15px"
              class="upload-demo"
              :with-credentials="true"
              multiple
              :limit="1"
              accept=".mp4,.txt"
              :auto-upload="true"
              :headers="{ Authorization: token }"
              :show-file-list="true"
              ref="uploadVideo"
              :on-success="handleAvatarSuccess"
              :file-list="fileList"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
              <div class="el-upload__tip" slot="tip">只能上传mp4文件</div>
            </el-upload>
          </el-form-item>
          <el-form-item label="小说链接">
            <el-input v-model="addEpisodeForm.url" placeholder="" disabled></el-input>
          </el-form-item>
          <el-form-item label="小说大小">
            <el-input v-model="addEpisodeForm.size" placeholder="" disabled></el-input>
          </el-form-item>
          <el-form-item label="小说类型">
            <el-input v-model="addEpisodeForm.fileExt" disabled placeholder=""></el-input>
          </el-form-item>

          <el-form-item label="图片">
            <el-input
              v-model="addEpisodeForm.image"
              placeholder="请选输入图片链接"
            ></el-input>
          </el-form-item>
          <el-form-item label="是否需要广告">
            <el-select v-model="addEpisodeForm.needAd">
              <el-option label="是" :value="1"></el-option>
              <el-option label="否" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否需要付费">
            <el-select v-model="addEpisodeForm.needPay">
              <el-option label="是" :value="1"></el-option>
              <el-option label="否" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="金币">
            <el-input
              v-model="addEpisodeForm.payPrice"
              placeholder="请选输入支付金币"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible2 = false">取 消</el-button>
          <el-button type="primary" @click="submitAddEpisodeForm">确 定</el-button>
        </div>
      </el-dialog>
    </el-row>
  </div>
</template>

<script>
import { axiosGet, axiosPost } from "@/assets/ajaxFn";
import episodeManager from "./episodeManager.vue";
export default {
  components: { episodeManager },
  data() {
    return {
      videoId: 0,
      movieName: "",
      dialogFormVisible1: false,
      dialogFormVisible2: false,
      total: 0,
      videoList: [],
      categoryList: [],
      videoSearch: {
        categoryId: "",
        currentPage: 1,
        enabled: "",
        endTime: "",
        hot: "",
        movieName: "",
        pageSize: 50,
        recommend: "",
        startTime: "",
        type: "Novel",
        domain:"",
        vastLink: "",

      },
      dialogFormVisible: false,
      string: "添加",
      loading: false,
      rules: {
        coinPrice: [
          { required: true, message: "请输入解锁小说所需金币数量", trigger: "blur" },
        ],
        freeEpisode: [{ required: true, message: "请输入小说免费集数", trigger: "blur" }],
        coinRate: [
          { required: true, message: "请输入解锁小说金币递增数量", trigger: "blur" },
        ],
        author: [{ required: true, message: "请输入作者名称", trigger: "blur" }],
        movieName: [{ required: true, message: "请输入小说名称", trigger: "blur" }],
        cover: [{ required: true, message: "请输入封面大图链接", trigger: "blur" }],
        largeCover: [{ required: true, message: "请输入封面大图链接", trigger: "blur" }],
        categoryIdList: [{ required: true, message: "请选择小说分类", trigger: "blur" }],
        totalEpisode: [
          { required: true, message: "请输入小说集数", trigger: "blur" },
          {
            pattern: /^(\d+|\d*\\d{1,10})$/,
            message: "小说集数只能是整数",
            trigger: "blur",
          },
        ],
      },
      addVideoForm: {
        author: "",
        lang: "en",
        categoryIdList: [],
        country: "",
        cover: "",
        enabled: 1,
        hot: 1,
        movieName: "",
        publishBy: "",
        publishByName: "",
        publishTime: "",
        recommend: 0,
        summary: "",
        tagNameList: [],
        totalEpisode: "",
        type: "Novel",
        largeCover: "",
        vastLink: "",
        coinPrice: 0,
        coinRate: 0,
        freeEpisode: 1,
        sortNumber: 0,
      },
      tagNameListPage: [
        "Love After Divorce",
        "Love After Marriage",
        "Taboo",
        "Fated Lovers",
        "Flash Marriage",
        "Revenge",
        "Enemies to Lovers",
        "Werewolf",
        "Friends to Lovers",
        "Fantasy",
      ],
      edit: false,
      addEpisodeForm: {
        episode: "",
        episodeName: "",
        fileExt: "",
        image: "",
        movieId: "",
        needAd: "",
        needPay: "",
        payPrice: "",
        size: "",
        summary: "",
        url: "",
      },
      fileList: [],
      fileList1: [],
      fileList2: [],
      token: JSON.parse(sessionStorage.getItem("loginData")).token,
      multipleSelection: [],
      domainList:[],
      domain:""
    };
  },
  methods: {
   async addMovieToDm(){
      if(!this.domain){
        this.$message({message:"请先选择域名",type:"error"});
        return false;
      }
      if(!this.multipleSelection.length){
        this.$message({message:"请至少选择一个小说",type:"error"});
        console.log(this.multipleSelection);
        return false;
      }else{
        this.loading=true;
        let movieIds=[];
        this.multipleSelection.forEach(item=>{
          movieIds.push(item.id);
        })
       await axiosPost('/api/movie/add_domain',{domain:this.domain,movieId:movieIds.join(",")},"JSON").then(res=>{
          if(res.code==0){
            movieIds=[];
            this.$refs.multipleTable.clearSelection();
          }
        });
        await axiosPost('/api/movie/make/list_json',{domain:this.domain,type:'Novel'},"JSON").then(res=>{
          if(res.code==0){
            movieIds=[];
            this.$refs.multipleTable.clearSelection();
            // this.$message({message:"小说加入域名成功,JSON文件生成成功",type:"success"});
          }
        });
        await axiosPost('/api/movie/make/list_recommend_hot_json',{domain:this.domain,type:"recommend",dataType:'Novel'},"JSON").then(res=>{
          if(res.code==0){
            movieIds=[];
            this.$refs.multipleTable.clearSelection();
            this.$message({message:"小说加入域名成功,JSON文件生成成功",type:"success"});
          }
        });
        this.loading=false;
      }

    },
    removeMovieToDm(){
      if(!this.domain){
        this.$message({message:"请先选择域名",type:"error"});
        return false;
      }
      if(!this.multipleSelection.length){
        this.$message({message:"请至少选择一个小说",type:"error"});
        return false;
      }else{
        let movieIds=[];
        this.multipleSelection.forEach(item=>{
          movieIds.push(item.id);
        })
        // axiosPost('/api/movie/add_domain',{domain:this.domain,movieId:movieIds.join(",")},"JSON").then(res=>{
        //   if(res.code==0){
        //     movieIds=[];
        //     this.$refs.multipleTable.clearSelection();
        //     this.$message({message:"小说加入域名成功",type:"success"});
        //   }
        // })
      }

    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleAvatarSuccessImgLarge(res) {
      if (res.code == 0) {
        this.addVideoForm.largeCover = res.data.url;
        this.$forceUpdate(); // 强制更新页面上的表单内容
        this.$refs.uploadLargeCover.clearFiles();
      }
    },
    handleAvatarSuccessImg(res) {
      if (res.code == 0) {
        this.addVideoForm.cover = res.data.url;
        this.$refs.uploadCover.clearFiles();
        this.$forceUpdate();
        // this.$refs.uploadLargeCover.clearFiles();
      }
      // this.addVideoForm.cover=
    },
    handleAvatarSuccess(res) {
      if (res.code == 0) {
        this.addEpisodeForm.url = res.data.url;
        this.addEpisodeForm.size = res.data.size;
        this.addEpisodeForm.fileExt = res.data.ext;
        this.$refs.uploadVideo.clearFiles();
      }
    },
    async getDomainList() {
      await axiosGet("/api/domains/list", { currentPage: 1, pageSize: 50 ,dmType:4}).then(
        (res) => {
          if (res.code == 0) {
            this.domainList = res.data.records;
          }
        }
      );
    },
    submitAddEpisodeForm() {
      axiosPost("/api/movie/episode/add", this.addEpisodeForm, "JSON").then((res) => {
        if (res.code == 0) {
          this.$message({ message: "添加章节成功", type: "success" });
          this.dialogFormVisible2 = false;
        }
      });
    },
    addEpisodeForThis(row) {
      this.addEpisodeForm.movieId = row.id;
      this.dialogFormVisible2 = true;
    },
    async getList(params) {
      this.loading = true;
      let copyParams={
        categoryId: "",
        currentPage: params.currentPage||1,
        enabled: "",
        endTime: "",
        hot: "",
        movieName: "",
        pageSize: params.pageSize||50,
        recommend: "",
        startTime: "",
        type: "Novel",
        domain:"",
        vastLink: "",

      }
      await axiosGet("/api/movie/list", copyParams).then((res) => {
        if (res.code == 0) {
          this.videoList = res.data.records;
          this.total = res.data.total;
        }
      });
     if(params.domain){
      await axiosGet("/api/movie/list",params).then(result=>{
        if(result.code==0){
          if(result.data.records){
            result.data.records.forEach(item=>{
              const matchedRow = this.videoList.find(row => row.id === item.id);
              if (matchedRow) {
                this.$refs.multipleTable.toggleRowSelection(matchedRow, true);
              }
            })
          };
        }
      })
     }
      this.loading = false;
    },
    toggleSelection(rows) {
        if (rows) {
          rows.forEach(row => {
            this.$refs.multipleTable.toggleRowSelection(row);
          });
        }
      },
    checkEpisodeForThis(row) {
      this.videoId = row.id;
      this.movieName = row.movieName;
      this.dialogFormVisible1 = true;
    },
    deleteVideo(row) {
      this.$confirm("是否要删除 " + row.movieName + "?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          axiosPost("/api/movie/delete", { id: row.id }, "JSON").then((res) => {
            if (res.code == 0) {
              this.getList(this.videoSearch);
              this.$message({ message: "删除成功", type: "success" });
            }
          });
        })
        .catch(() => {});
    },
    addVideo() {
      this.edit = false;
      this.string = "添加";
      this.addVideoForm = {
        author: "",
        lang: "en",
        categoryIdList: [],
        country: "",
        cover: "",
        enabled: 1,
        hot: 1,
        movieName: "",
        publishBy: "",
        publishByName: "",
        publishTime: "",
        recommend: 0,
        summary: "",
        tagNameList: [],
        totalEpisode: "",
        type: "Novel",
        largeCover: "",
        vastLink: "",
        coinPrice: 0,
        coinRate: 0,
        freeEpisode: 1,
        sortNumber: 0,
      };
      this.dialogFormVisible = true;
    },
    updateVideo(row) {
      this.addVideoForm = {
        author: row.author,
        categoryIdList: row.categoryIdList,
        cover: row.cover,
        enabled: row.enabled || 0,
        hot: row.hot || 0,
        movieName: row.movieName,
        publishBy: "",
        publishByName: "",
        publishTime: "",
        recommend: row.recommend || 0,
        summary: row.summary,
        tagNameList: row.tagNameList,
        totalEpisode: row.totalEpisode,
        largeCover: row.largeCover,
        id: row.id,
        type: "Novel",
        vastLink: row.vastLink || "",
        lang: row.lang || "en",
        coinPrice: row.coinPrice || 0,
        coinRate: row.coinRate || 0,
        freeEpisode: row.freeEpisode || 0,
        sortNumber: row.sortNumber || 0,
      };
      this.edit = true;
      this.string = "更新";
      this.dialogFormVisible = true;
    },
    getCategoryList() {
      this.loading = true;
      axiosGet("/api/movie/category/list?type=Novel").then((res) => {
        if (res.code == 0) {
          if (res.data) {
            this.categoryList = res.data;
          }

          this.loading = false;
        }
      });
    },
    async submitVideoForm(formName) {
      console.log(this.addVideoForm);
      const valid = await new Promise((resolve) => {
        this.$refs[formName].validate((valid) => {
          resolve(valid);
        });
      });
      if (valid) {
        let url = this.edit ? "/api/movie/update" : "/api/movie/add";
        axiosPost(url, this.addVideoForm, "JSON").then((res) => {
          if (res.code == 0) {
            this.$message({ message: "小说" + this.string + "成功", type: "success" });
            this.dialogFormVisible = false;
            this.getList(this.videoSearch);
          }
        });
      }
    },
    handleSizeChange(val) {
      this.videoSearch.pageSize = val;
      this.getList(this.videoSearch);
    },
    handleCurrentChange(val) {
      this.videoSearch.currentPage = val;
      this.getList(this.videoSearch);
    },
    addMovieToDomain(row) {
      // axiosPost('/api/movie/add_domain',{domain:"",})
    },
    shareHtml(row){
      if(!this.domain){
        this.$message({message:"请先选择域名",type:"error"});
      }else{
        this.$alert(`https://${this.domain}/video.html?id=${row.id}`, '提示', {
          confirmButtonText: '确定',
          callback: action => {}
        });
      }
    },
    domainChange(val){
      this.videoSearch.domain=val;
      this.getList(this.videoSearch)
    }
  },
  mounted() {

    this.getCategoryList();
    this.domain=sessionStorage.getItem("needDm")||"";
    this.videoSearch.domain=this.domain;
    this.getList(this.videoSearch);
    this.getDomainList();
  },
  destroyed() {
    sessionStorage.removeItem('needDm');
  },
};
</script>



// WEBPACK FOOTER //
// src/components/view/novelManager/novelList.vue